import { isTabletFormFactor } from './mobileView';
import { isMobileShellLayout } from './mobileShellLayout';

/**
 * Web tablet Safari / wide touch layouts that are NOT in the mobile app shell.
 * Native tablets always use the app shell, so this stays false there.
 */
export function isInsightsTabletLayout() {
  return isTabletFormFactor() && !isMobileShellLayout();
}

/** KPI cards: 2×2 on tablet until xl; 4-across from lg on desktop. */
export function getInsightsMetricGridProps(isTablet = isInsightsTabletLayout()) {
  return isTablet ? { xs: 12, sm: 6, xl: 3 } : { xs: 12, sm: 6, lg: 3 };
}

/** Wide chart column — stack below xl on tablet. */
export function getInsightsChartPrimaryGridProps(isTablet = isInsightsTabletLayout()) {
  return isTablet ? { xs: 12, xl: 8 } : { xs: 12, lg: 8 };
}

/** Side panel charts (payment methods, sources) — full width until xl on tablet. */
export function getInsightsChartSecondaryGridProps(isTablet = isInsightsTabletLayout()) {
  return isTablet ? { xs: 12, xl: 4 } : { xs: 12, lg: 4 };
}

/** Two equal chart columns — stack until lg/xl. */
export function getInsightsSplitChartGridProps(isTablet = isInsightsTabletLayout()) {
  return isTablet ? { xs: 12, xl: 6 } : { xs: 12, lg: 6 };
}

/** Grid row spacing — slightly tighter on tablet. */
export function getInsightsGridSpacing(isTablet = isInsightsTabletLayout()) {
  return isTablet ? 2 : 3;
}
